export enum PolicyAssignationType {
  CUSTOM = 0,
  INHERITED = 1,
}

export interface AssignPolicyFormValue {
  assignationType: PolicyAssignationType;
  enforced: boolean;
  policyId: string;
}
